import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { IRootStore } from "../../redux";
import { logIn } from "../../redux/authReducer/actions";
import LoginContentContainer from "./LoginContent.container";
import { getAppProps } from "../../redux/appPropsReducer/selectors";

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators({ logIn }, dispatch);

const mapStateToProps = (state: IRootStore) => ({
  appProps: getAppProps(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContentContainer);
